import HTTP from "@/_helpers/http";
import { CRYPTO__API } from "@/_helpers/urls";
import { CRYPTO__MUTATIONS } from "../mutation-types";
import { CRYPTO__ACTIONS } from "../action-types";
import toast from "@/services/Notification";
import router from "@/router";

// State
const state = {
    cryptoaddresses: [],
    cryptodetails: {},
    networks: [],
    ovypaycrypto:null
};

//Getters
const getters = {};

//Mutations
const mutations = {
    [CRYPTO__MUTATIONS.GETALL](state, data) {
        state.cryptoaddresses = data;
    },
    [CRYPTO__MUTATIONS.NETWORKS](state, data) {
        state.networks = data;
    },
    [CRYPTO__MUTATIONS.OVYPAY](state, data) {
        state.ovypaycrypto = data;
    },
    [CRYPTO__MUTATIONS.DETAILS](state, data) {
        state.cryptodetails = data;
    },
};

// Actions
const actions = {
    async [CRYPTO__ACTIONS.NETWORKS]({ commit, state }) {
        try {
            const url = `${CRYPTO__API.NETWORKS}`;
            const response = await HTTP({
                trackProgress: true,
                loadingText: 'Processing...'
            }).get(url);
            commit(CRYPTO__MUTATIONS.NETWORKS, response.data);
        } catch (error) {
            console.log(error);
        }
    },
    async [CRYPTO__ACTIONS.OVYPAY]({ commit, state }) {
        try {
            const url = `${CRYPTO__API.OVYPAY}`;
            const response = await HTTP({
                trackProgress: true,
                loadingText: 'Processing...'
            }).get(url);
            commit(CRYPTO__MUTATIONS.OVYPAY, response.data);
        } catch (error) {
            console.log(error);
        }
    },
    async [CRYPTO__ACTIONS.GETALL]({ commit, state }) {
        try {
            const url = `${CRYPTO__API.GETALL}`;
            const response = await HTTP({
                trackProgress: true,
                loadingText: 'Processing...'
            }).get(url);
            commit(CRYPTO__MUTATIONS.GETALL, response.data);
        } catch (error) {
            console.log(error);
        }
    },

    async [CRYPTO__ACTIONS.DETAILS]({ commit, state }, id) {
        try {
            const url = `${CRYPTO__API.DETAILS}/${id}`;
            const response = await HTTP({
                trackProgress: true,
                loadingText: 'Processing...'
            }).get(url);
            commit(CRYPTO__MUTATIONS.DETAILS, response.data);
        } catch (error) {
            console.log(error);
        }
    },

    async [CRYPTO__ACTIONS.CREATE]({ commit, state, dispatch }, data) {
        try {
            const url = `${CRYPTO__API.CREATE}`;
            const res = await HTTP({
                trackProgress: true,
                loadingText: 'Processing...'
            }).post(url, data);
            toast.success(res.data.message)
            dispatch(CRYPTO__ACTIONS.GETALL);
            setTimeout(() => {
                router.push('/bank-information?tab=3').catch(err => {
                    if (err.name !== 'NavigationDuplicated') {
                        throw err;
                    }
                });
            }, 1000)
        } catch (error) {
            console.log(error);
        }
    },
};

export default {
    namespaced: true,
    strict: process.env.NODE_ENV !== "production",
    state,
    getters,
    mutations,
    actions,
};
